import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import axios from 'axios';
import SearchableSelect from './SearchableSelect';

/**
 * "Parent item": files a material under a parent item (Round Pad Lock, 50mm: Padlock). Optional. The material stays its own item,
 * with its own stock and cost; the parent item only groups it. Offers shared items and the organization's own that are not themselves types.
 */
function GenericItemPicker({ value, onChange, excludeId, categoryId }) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let cancelled = false;
    axios.get('/api/organization-materials/generic-items', { params: { include: value || undefined, exclude: excludeId || undefined, category: categoryId || undefined } })
      .then((r) => {
        if (cancelled) return;
        setOptions((Array.isArray(r.data) ? r.data : []).map((i) => ({ value: String(i.id), label: i.name, subtitle: i.category, categoryId: i.categoryId })));
      })
      .catch(() => { if (!cancelled) setOptions([]); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [excludeId, categoryId]);

  return (
    <Form.Group className="mb-3">
      <Form.Label>Parent item (optional)</Form.Label>
      <div className="d-flex gap-2 align-items-start">
        <div className="flex-grow-1">
          <SearchableSelect
            options={options}
            value={value ? String(value) : ''}
            onChange={(v) => onChange(v || '', options.find((o) => o.value === v))}
            placeholder="Type to search, for example Padlock"
            emptyLabel="No matching parent item"
          />
        </div>
      </div>
      <Form.Text className="text-muted">
        For a size, brand or model of something general, such as Padlock. It goes in the same category, and stays a separate material with its own stock, cost and reorder levels.
      </Form.Text>
    </Form.Group>
  );
}

export default GenericItemPicker;
